export enum ECreditFlowApiUrl {
  fundingLoanProducts = '/api/credit-flow-backend/v1/get_by_options-funding-product',
  installmentCalculator = '/api/credit-flow-backend/v1/installment/get_calculate-payment-amount',
  installmentCalculatorSber = '/api/credit-flow-backend/v1/installment/get_calculate-payment-amount-sber',
  fundingRequests = '/api/credit-flow-backend/v1/fundings',
}
